import {APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {IonicModule, IonicRouteStrategy} from '@ionic/angular';
import {RouteReuseStrategy, Router} from '@angular/router';
import {TraceService} from '@sentry/angular';
import {GlobalErrorHandler} from './services/monitoring/global-error-handler';
import {ReactiveFormsModule} from '@angular/forms';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {NgChartsModule} from 'ng2-charts';
import {NgOptimizedImage} from '@angular/common';
import {ServiceWorkerModule} from '@angular/service-worker';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule, provideHttpClient, withFetch} from '@angular/common/http';
import {Capacitor} from '@capacitor/core';
import {AuthGuard} from './guards/auth.guard';
import {environment} from "../environments/environment";
import {initializeApp} from "firebase/app";
import {HttpTimeoutInterceptor} from './http-timeout.interceptor';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {CdnTranslateLoader} from './services/cdn-translate-loader';
import {SessionExpiryBannerComponent} from './shared/session-expiry-banner/session-expiry-banner.component';

const ngImports = [
  BrowserModule,
  IonicModule.forRoot({ mode: 'ios', innerHTMLTemplatesEnabled: true }),
  ReactiveFormsModule,
  AppRoutingModule,
  NgChartsModule,
  NgOptimizedImage,
  HttpClientModule,
  TranslateModule.forRoot({
    defaultLanguage: 'en',
    loader: {
      provide: TranslateLoader,
      useClass: CdnTranslateLoader,
      deps: [HttpClient],
    },
  }),
  SessionExpiryBannerComponent,
];

if (!Capacitor.isNativePlatform()) {
  initializeApp(environment.firebase);
  ngImports.push(ServiceWorkerModule.register('ngsw-worker.js', {
    enabled: environment.production,
    registrationStrategy: 'registerWhenStable:30000',
  }));
}

@NgModule({
  declarations: [AppComponent],
  imports: ngImports,
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    AuthGuard,
    { provide: HTTP_INTERCEPTORS, useClass: HttpTimeoutInterceptor, multi: true },
    [provideHttpClient(withFetch())],
    // ── Monitoring: unified error handler bridges Sentry + Firebase Crashlytics.
    // TraceService + APP_INITIALIZER wire Sentry performance tracing to the Router.
    // All three no-op safely when Sentry was not initialised (empty DSN).
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: TraceService, deps: [Router] },
    { provide: APP_INITIALIZER, useFactory: () => () => {}, deps: [TraceService], multi: true },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}
